import { useEffect } from 'react';
import * as QuestionnaireApiModels from '@typings/questionnaires-api-models';
import evaluateExpression from '@/helpers/evaluateExpression';
import { useFormContext } from '@/context/FormContext';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@tsClient';
import useVariableValues from '../../helpers/useVariableValues';

type Props = {
  section: Pick<QuestionnaireApiModels.SectionTemplate, 'id' | 'pdfTemplateId'> & {
    conditionExpression:
      & Pick<QuestionnaireApiModels.Expression, 'expression'>
      & {
      variables: Parameters<typeof useVariableValues>[0];
    } | null;
  };
};

const HandleSectionCondition: React.FC<Props> = ({ section }) => {
  const {
    setSectionVisibility,
    userWorkflowId,
    questionnaireId,
  } = useFormContext();

  const { getData: deleteUserWorkflowDocumentFn } = useNoodleApi(tsClient.workflows.deleteUserWorkflowDocument);
  const { getData: generateFormPdfDocument } = useNoodleApi(tsClient.workflows.generateFormPDF);

  const variables = useVariableValues(section.conditionExpression?.variables ?? null);

  useEffect(() => {
    if (!section.conditionExpression) {
      setSectionVisibility(section.id, true);
    } else {
      const result = evaluateExpression({
        expression: section.conditionExpression.expression,
        id: `HandleSectionCondition-${section.id}`,
        variables,
      });
      setSectionVisibility(section.id, Boolean(result));
      if (userWorkflowId && section.pdfTemplateId) {
        if (!result) {
          deleteUserWorkflowDocumentFn({
            referenceId: section.pdfTemplateId,
            referenceType: 'questionnaire-pdf-fill',
            userWorkflowId,
          });
        } else {
          generateFormPdfDocument({
            pdfTemplateId: section.pdfTemplateId,
            questionnaireId,
            userWorkflowId,
          });
        }
      }
    }
  }, [
    variables,
    section.conditionExpression,
    section.id,
    section.pdfTemplateId,
    setSectionVisibility,
    userWorkflowId,
    deleteUserWorkflowDocumentFn,
    generateFormPdfDocument,
    questionnaireId,
  ]);

  return null;
};

export default HandleSectionCondition;
